import React from 'react';

class SMFormLargeImageView extends React.Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      imageUrl: this.props.imageUrl,
    };
  }
  
  componentDidMount() {
    $(".form-img-lightbox__close").on("click", ()=>{
      $(document).trigger("SMHideDialog");
    });
  }
  
  componentWillUnmount() {
    $(".form-img-lightbox__close").off("click");
  }
  
  render() {
    return (
      <div ref="form" className="form-img-lightbox">
        <img src={this.props.imageUrl} alt={this.props.title} width="600" />
        <a href="#" className="form-img-lightbox__close">
          <i className="fa fa-times"></i>
        </a>
      </div>
    );
  }
}

export default SMFormLargeImageView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormLargeImageView.jsx